"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientAppList = exports.ClientAppRecord = exports.ClientApplication = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const entity_1 = require("../../../../../entity");
const client_application_1 = require("../../../../client-application");
Object.defineProperty(exports, "ClientApplication", { enumerable: true, get: function () { return client_application_1.ClientApplication; } });
const field_1 = require("../../../openapi/field");
exports.NAMESPACE = 'Culligan.Api.V1.Admin.ClientApp.Schema';
exports.ClientAppRecord = effect_1.Schema.Struct({
    ...client_application_1.ClientApplication.fields,
    createdAt: effect_1.Schema.optionalWith(entity_1.CreatedAt, { exact: true }),
    updatedAt: effect_1.Schema.optionalWith(entity_1.UpdatedAt, { exact: true }),
    partitionKey: (0, field_1.optionalString)('Cosmos partition key persisted on stored rows. Defaults to "default".'),
}).annotations({
    identifier: `${exports.NAMESPACE}.ClientAppRecord`,
    description: 'Client application row as stored. Timestamps are absent on migration inserts; partitionKey is present on stored rows.',
});
exports.ClientAppList = effect_1.Schema.Struct({
    items: effect_1.Schema.propertySignature(effect_1.Schema.Array(exports.ClientAppRecord)).annotations({
        description: 'Every client application. Not filtered by tenant or caller role. ' +
            'Older records may omit tenantId (treat as the root tenant) and timestamps. ' +
            'Stored rows include partitionKey.',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ClientAppList`,
    description: 'List of client applications',
});
//# sourceMappingURL=schema.js.map